import s from './style.module.scss';
import { contentType } from '@/utils/Page/constant';
import AgentInfo from '../AgentInfo';
import CardButton from './CardButton';
import { Display } from '@/components/Display/Display';
const UserCards = (props) => {
    const { sessionId, curSkill: { ability_scene_list = [] } = {}, onSubmitMsg, setShowCaseCard, expand } = props;
    const handleSendCase = (card) => {
        const requestChatParams = {
            question: '',
            content_type: contentType.card,
            stream: true,
            component: {
                id: card.id,
                title: card.scene_name,
                describe: card.scene_describe
            }
        };
        setShowCaseCard(false);
        onSubmitMsg(requestChatParams, false);
    };
    return (
        <>
            <div className={s['card-box-wrap']} data-in-chat-expand={sessionId && expand}>
                <Display show={expand || !sessionId}>
                    <div className={s['card-content']}>
                        <Display show={!sessionId}>
                            <AgentInfo />
                        </Display>
                        <div className={s['card-box']}>
                            {ability_scene_list &&
                                ability_scene_list.map((card, index) => {
                                    let id = index > 5 ? 6 : index + 1;
                                    return (
                                        index < 6 && (
                                            <div
                                                key={card.id}
                                                style={{
                                                    backgroundImage: `url(${require(`@/assets/images//mobile/simulation/card_bg_${id}.png`)})`
                                                }}
                                                onClick={() => handleSendCase(card)}
                                                data-index={index}
                                                className={`${s['card']}`}
                                            >
                                                <div className={s['card-title']}>{card.scene_name}</div>
                                                <div className={s['card-description']}>{card.scene_describe}</div>
                                            </div>
                                        )
                                    );
                                })}
                        </div>
                    </div>
                </Display>
                {/* 有会话才显示 */}
                <Display show={sessionId}>
                    <CardButton setShowCaseCard={setShowCaseCard} expand={expand} />
                </Display>
            </div>
        </>
    );
};

export default UserCards;
